import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/rootReducer';
import PixiRenderer from '../components/PixiRenderer';
import { generateWorldThunk } from '../store/slices/gameSlice';
import { AppDispatch } from '../store/store';

const MapPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const world = useSelector((state: RootState) => state.game.world);
  const isGenerating = useSelector((state: RootState) => state.game.isGeneratingWorld);

  useEffect(() => {
    if (!world && !isGenerating) {
      dispatch(generateWorldThunk());
    }
  }, [world, isGenerating, dispatch]);

  if (isGenerating) {
    return <div>Generating world...</div>;
  }

  if (!world) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1>Game Map</h1>
      <PixiRenderer world={world} />
    </div>
  );
};

export default MapPage;
